import { Link } from 'react-router-dom'

const footerLinks = {
  company: [
    { label: 'For Advisers', href: '/advisers' },
    { label: 'Contact', href: '/mortgage-advisers/contact' },
  ],
  legal: [
    { label: 'Privacy Policy', href: '/privacy-policy' },
    { label: 'Terms of Service', href: '/terms' },
    { label: 'Security', href: '/security' },
  ],
}

export default function MortgageFooter() {
  return (
    <footer className="w-full bg-black/30 border-t border-white/[0.06] pt-16 pb-10 px-6 relative z-[1]">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-[1.5fr_1fr_1fr] gap-12 pb-12 border-b border-white/[0.06]">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3 no-underline">
              <svg className="w-8 h-8" viewBox="0 0 64 64" fill="none">
                <defs>
                  <linearGradient id="mortgageFooterEggLight" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#5eead4" />
                    <stop offset="100%" stopColor="#14b8a6" />
                  </linearGradient>
                  <linearGradient id="mortgageFooterEggMid" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#14b8a6" />
                    <stop offset="100%" stopColor="#0d9488" />
                  </linearGradient>
                  <linearGradient id="mortgageFooterEggDark" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#0d9488" />
                    <stop offset="100%" stopColor="#0f766e" />
                  </linearGradient>
                </defs>
                <path
                  d="M32 4 C18 4 8 20 8 36 C8 52 18 60 32 60 C46 60 56 52 56 36 C56 20 46 4 32 4Z"
                  fill="url(#mortgageFooterEggLight)"
                />
                <path
                  d="M12 38 Q22 32 32 38 Q42 44 52 38 L52 48 Q42 54 32 48 Q22 54 12 48 Z"
                  fill="url(#mortgageFooterEggMid)"
                  opacity="0.9"
                />
                <path
                  d="M14 46 Q24 40 32 46 Q40 52 50 46 L50 54 Q40 60 32 54 Q24 60 14 54 Z"
                  fill="url(#mortgageFooterEggDark)"
                  opacity="0.85"
                />
                <path d="M20 24 Q26 20 32 24" stroke="#B8956A" strokeWidth="2" strokeLinecap="round" fill="none" opacity="0.7" />
                <path d="M36 20 Q40 18 44 20" stroke="#B8956A" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.5" />
              </svg>
              <div className="font-serif text-[22px] font-medium tracking-tight text-brand-light">
                Wealth<span className="text-accent-tealLight">Space</span>
              </div>
            </Link>
            <p className="text-[15px] text-brand-subtle leading-relaxed mt-5 max-w-[300px]">
              AI-powered software that transforms how mortgage advisers work, every single day.
            </p>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-[13px] font-semibold text-brand-muted uppercase tracking-[0.05em] mb-5">
              Company
            </h4>
            {footerLinks.company.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="block text-sm text-brand-subtle py-1.5 no-underline transition-colors duration-300 hover:text-brand-light"
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-[13px] font-semibold text-brand-muted uppercase tracking-[0.05em] mb-5">
              Legal
            </h4>
            {footerLinks.legal.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="block text-sm text-brand-subtle py-1.5 no-underline transition-colors duration-300 hover:text-brand-light"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row justify-between items-center pt-[30px] gap-5">
          <p className="text-[13px] text-brand-subtle text-center sm:text-left">
            &copy; {new Date().getFullYear()} WealthSpace Ltd (Company No. 15396707). Registered in
            England &amp; Wales.
          </p>
        </div>
      </div>
    </footer>
  )
}
